let Vue = require('vue');
let FeatureIntro = require('../lib/components/Holocron/FeatureIntro.vue').default;

export default function () {
  Array.from(document.getElementsByClassName('feature-intro')).forEach(
    featureIntro => {
      new Vue({
        el: featureIntro,
        components: {
          'feature-intro': FeatureIntro
        }
      });
    }
  );
}
